import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  active: false,
  stepIndex: 0,
};

const tourSlice = createSlice({
  name: "tour",
  initialState,
  reducers: {
    startTour(state) {
      state.active = true;
      state.stepIndex = 0;
    },
    stopTour(state) {
      state.active = false;
    },
    nextTourStep(state) {
      state.stepIndex += 1;
    },
    prevTourStep(state) {
      state.stepIndex = Math.max(0, state.stepIndex - 1);
    },
  },
});

export const { startTour, stopTour, nextTourStep, prevTourStep } = tourSlice.actions;
export default tourSlice.reducer;
